export default {
  init() {

    if ($('.home-hero__slider').children().length > 1) {
      $('.home-hero__slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        autoplaySpeed: 5000,
        fade: true,
        autoplay: true,
        arrows: true,
        prevArrow:
          '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
        nextArrow:
          '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
        pauseOnHover: false,
        appendDots: $('.home-hero'),
      });
    }

    $('.home-releases__slider').slick({
      dots: false,
      infinite: true,
      // speed: 2000,
      // autoplaySpeed: 0,
      // fade: true,
      // cssEase: 'linear',
      autoplay: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
      // pauseOnHover: false,
      slidesToShow: 5,
      // touchMove: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.home-sponsors__slider').slick({
      dots: false,
      infinite: true,
      // speed: 2000,
      // autoplaySpeed: 0,
      // fade: true,
      // cssEase: 'linear',
      autoplay: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
      // pauseOnHover: false,
      slidesToShow: 6,
      // touchMove: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    });

    $('.home-testimonials__slider').slick({
      dots: false,
      infinite: true,
      // speed: 2000,
      // autoplaySpeed: 0,
      // fade: true,
      // cssEase: 'linear',
      autoplay: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
      // pauseOnHover: false,
      slidesToShow: 1,
      // touchMove: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });

    $('.home-news__slider').slick({
      dots: true,
      infinite: true,
      // speed: 2000,
      // autoplaySpeed: 0,
      // fade: true,
      // cssEase: 'linear',
      appendArrows: '.testimonials',
      autoplay: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fal fa-angle-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fal fa-angle-right"></i></button>',
      // pauseOnHover: false,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js